import { render, staticRenderFns } from "./PatientCreateModal.vue?vue&type=template&id=60af7fc2&scoped=true"
import script from "./PatientCreateModal.vue?vue&type=script&lang=js"
export * from "./PatientCreateModal.vue?vue&type=script&lang=js"
import style0 from "./PatientCreateModal.vue?vue&type=style&index=0&id=60af7fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60af7fc2",
  null
  
)

export default component.exports